export function money(value: number | string | null | undefined): string {
  const num = Number(value ?? 0)
  return 'RM ' + num.toLocaleString('en-MY', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

/**
 * What an order line costs: the server's line_total, which is an agreed total
 * exactly as typed (or a line priced by size group, summed), else qty x unit_price. Multiplying the rounded unit price
 * of an agreed line back can miss by a sen (RM100 for 3 pcs is 33.33 each).
 */
export function lineTotal(item: { qty: number; unit_price?: number; line_total?: number }): number {
  return item.line_total ?? item.qty * (item.unit_price ?? 0)
}

/**
 * One price row of a line split by size price group, as "Kids: 3 pcs x RM 15.00".
 * A row with no group is the product's own price, named "Standard".
 */
export function priceRowLabel(row: { group: string | null; qty: number; price: number }): string {
  return `${row.group ?? 'Standard'}: ${row.qty} pcs x ${money(row.price)}`
}
